import { MultiSelect, Text, rem } from '@mantine/core';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { BiSolidDownArrow } from 'react-icons/bi';
import { useState } from 'react';
import { useEmployeeFormContext } from '../NewEmployeePage';

interface Location {
  id: number;
  name: string;
}

export const LocationsCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const { data } = useSWR<{ content: Location[] }>('/localities', getFetcher);

  const locationOptions =
    data?.content?.map(location => ({
      value: location.id.toString(),
      label: location.name,
      id: location.id,
    })) ?? [];

  const handleChangeLocations = (values: string[]) => {
    setSelectedLocations(values);
    form.setFieldValue('locs', []);

    locationOptions.forEach(location => {
      if (values.includes(location.value))
        form.insertListItem('locs', location.id);
    });
  };

  return (
    <div>
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <Text fw={700} size="lg" style={{ marginRight: '5px' }}>
          Lokality
        </Text>
      </label>
      <div>
        <MultiSelect
          variant="default"
          radius="md"
          rightSection={icon}
          placeholder="vyberte lokality"
          value={selectedLocations}
          data={locationOptions}
          onChange={values => {
            handleChangeLocations(values);
          }}
        />
      </div>
    </div>
  );
};
